import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography, Modal, Paper, IconButton, Divider, Fade } from '@material-ui/core';
import { Cancel } from '@material-ui/icons';
import CustomButton from 'components/CustomInput/Button/index';
import LoadingIndicator from 'components/LoadingIndicator';

const useStyles = makeStyles((theme) => ({
    popupRoot: {
        width: '100%',
        height: '100%',
        // zIndex: '10000 !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: (props) => ({
        width: props.width,
        height: props.height,
        maxWidth: props.maxWidth,
        maxHeight: '95%',
        padding: props.padding,
        display: 'flex',
        flexDirection: 'column',
        '& .MuiCardHeader-root': {
            padding: '5px 10px',
        },
        '& .MuiCardHeader-action': {
            margin: '0px',
        },
        overflow: 'hidden',
    }),
    title: {
        fontWeight: 'bold',
        fontSize: '18px !important',
    },
    footer: {
        paddingTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
    },
    footerBtn: {
        marginLeft: theme.spacing(2),
    },
    divider: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    mainContainer: {
        flex: 1,
        overflowX: 'hidden',
        paddingBottom: 5,
        // overflowY: 'auto',
    },
}));

const Popup = (props) => {
    const extra = {};
    const { isLoading } = props;

    if (props.height) {
        extra.height = props.height;
    }

    const classes = useStyles({
        // height: props.height ? props.height : '95%',
        ...extra,
        width: props.width ? props.width : '',
        padding: props.padding ? props.padding : '10px 20px',
        maxWidth: props.maxWidth ? props.maxWidth : '95%',
        zIndex: props.zIndex ? props.zIndex : '1300',
    });

    const { footerActions, closePopup, open } = props;

    return (
        <Modal
            className={classes.popupRoot}
            open={open}
            closeAfterTransition
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <Paper elevation={3} variant="outlined" className={classes.paper}>
                    <Grid container wrap="nowrap" justify="space-between">
                        <Typography color="primary" className={classes.title}>
                            {props.title}
                        </Typography>
                        {closePopup && props.showHeaderExit && (
                            <IconButton size="small" onClick={closePopup}>
                                <Cancel color="primary" />
                            </IconButton>
                        )}
                    </Grid>
                    <Divider className={classes.divider} />
                    <Grid container alignItems="baseline" className={classes.mainContainer}>
                        {isLoading ? (
                            <Grid container alignItems="center" justify="center" style={{ height: '100%' }}>
                                <LoadingIndicator />
                            </Grid>
                        ) : (
                            props.children
                        )}
                    </Grid>
                    <Grid container className={classes.footer} justify="flex-end">
                        {footerActions.map((item) => (
                            <CustomButton
                                className={classes.footerBtn}
                                key={item.label}
                                color={item.color ? item.color : 'primary'}
                                disabled={item.disabled}
                                onClick={item.clicked ? item.clicked : closePopup}
                            >
                                {item.label}
                            </CustomButton>
                        ))}
                    </Grid>
                </Paper>
            </Fade>
        </Modal>
    );
};

Popup.defaultProps = {
    header: true,
    footer: true,
    open: true,
    showHeaderExit: false,
    disableBackdropClick: true,
    footerActions: [
        {
            label: 'Close',
        },
    ],
};

Popup.propTypes = {
    children: PropTypes.any,
    closePopup: PropTypes.func,
    footer: PropTypes.bool,
    footerActions: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            clicked: PropTypes.func,
        }),
    ),
    header: PropTypes.bool,
    open: PropTypes.bool,
    saveClicked: PropTypes.func,
    title: PropTypes.string,
    showHeaderExit: PropTypes.bool,
};
export default Popup;
